var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMood5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.14 887.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#C285FF;}.cls-2{fill:#EBD4FD;}.cls-3{fill:#9A59DC;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.22,
    y: 621.01,
    width: 434.4,
    height: 47.23,
    rx: 23.61,
    transform: "translate(476.84 1289.25) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 238.57,
    cy: 238.57,
    r: 230.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.57,477.14c131.55,0,238.57-107,238.57-238.57S370.12,0,238.57,0,0,107,0,238.57,107,477.14,238.57,477.14Zm0-460.4c122.32,0,221.84,99.51,221.84,221.83S360.89,460.41,238.57,460.41,16.74,360.89,16.74,238.57,116.25,16.74,238.57,16.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.37,271.43H129.86a8.63,8.63,0,0,0-4.92,11.17,120.85,120.85,0,0,0,225.35,0A8.63,8.63,0,0,0,345.37,271.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.4,219.46,130,186.07a20.54,20.54,0,0,1,29.05-29l4.35,4.35,4.36-4.35a20.53,20.53,0,0,1,29,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M311.06,219.46l-33.4-33.39a20.53,20.53,0,0,1,29-29l4.36,4.35,4.36-4.35a20.53,20.53,0,0,1,29,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.24,824.2Q273,833.76,273,849.28a35.09,35.09,0,0,1-5.35,18.87q-5.37,8.61-16.54,14t-27.8,5.35A107.79,107.79,0,0,1,200.43,885a71.55,71.55,0,0,1-20-7.3l12.43-27a60.86,60.86,0,0,0,14.36,5.9,56.49,56.49,0,0,0,14.68,2,20.81,20.81,0,0,0,10.33-2.25q4-2.25,4-6.29a6.27,6.27,0,0,0-3.57-5.83q-3.58-1.93-12.89-1.94H188.24l5.44-66h72.21v27.64H223.8L223,814.65h5.59Q251.45,814.65,262.24,824.2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood5);
export default __webpack_public_path__ + "static/media/mood-5.326b0c8c.svg";
export { ForwardRef as ReactComponent };